export default __webpack_public_path__ + "static/media/camera.67de607b.svg";